const PrivateControleSessao = {
    tipo: '',
    id_usuario: 0,
    nome_usuario: '',
    token: '',
    refreshToken: '',
    id_empresa: 0,
    id_embarcador: 0,
    filiais: [],
    titulo: '',
    tipoEmbarcadora: '',
    possuiVinculoTransportadorExterno: false,
    visualizaChatMovidesk: true,
}

const ControleSessao = {
    setTipo: (tipo: string) => PrivateControleSessao.tipo = tipo,

    setIdUsuario: (id: number) => PrivateControleSessao.id_usuario = id,

    setNomeUsuario: (nome: string) => PrivateControleSessao.nome_usuario = nome,

    setToken: (token: string) => PrivateControleSessao.token = token,

    setIdEmpresa: (id_empresa: number) => PrivateControleSessao.id_empresa = id_empresa,

    setIdEmbarcador: (id_embarcador: number) => PrivateControleSessao.id_embarcador = id_embarcador,

    setFiliais: (filiais: { CAB_CODIGO: number, CAB_RAZAO: string }[]) => PrivateControleSessao.filiais = filiais,

    setRefreshToken: (token: string) => PrivateControleSessao.refreshToken = token,

    setCustomTitle: (titulo: string) => PrivateControleSessao.titulo = titulo,

    setTipoEmbarcadora: (tipoEmbarcadora: string) => PrivateControleSessao.tipoEmbarcadora = tipoEmbarcadora,

    setPossuiVinculoTransportadorExterno: (possui: boolean) => PrivateControleSessao.possuiVinculoTransportadorExterno = possui,

    setVisualizaChatMovidesk: (visualiza: boolean) => PrivateControleSessao.visualizaChatMovidesk = visualiza,

    getTipo: (): string => PrivateControleSessao.tipo,

    getIdUsuario: (): number => PrivateControleSessao.id_usuario,

    getNomeUsuario: (): string => PrivateControleSessao.nome_usuario,

    getToken: (): string => PrivateControleSessao.token,

    getUsuarioInterno: (): boolean => PrivateControleSessao.tipo == 'I',

    getIdEmpresa: (): number => PrivateControleSessao.id_empresa,

    getIdEmbarcador: (): number => PrivateControleSessao.id_embarcador,

    getFiliais: (): { CAB_CODIGO: number, CAB_RAZAO: string }[] => PrivateControleSessao.filiais,

    getRefreshToken: (): string => PrivateControleSessao.refreshToken,

    getCustomTitle: (): string => PrivateControleSessao.titulo,

    getTipoEmbarcadora: (): string => PrivateControleSessao.tipoEmbarcadora,

    getPossuiVinculoTransportadorExterno: (): boolean => PrivateControleSessao.possuiVinculoTransportadorExterno,

    getVisualizaChatMovidesk: (): boolean => PrivateControleSessao.visualizaChatMovidesk,
}

export default ControleSessao
